var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.303.6c.799-.8 2.095-.8 2.894 0l7.704 7.703a2.047 2.047 0 0 1 0 2.894l-7.704 7.704a2.047 2.047 0 0 1-2.894 0L.6 11.197c-.8-.799-.8-2.095 0-2.894zm1.654 1.24a.29.29 0 0 0-.414 0L1.84 9.543a.29.29 0 0 0 0 .414l7.703 7.703c.114.114.3.114.414 0l7.703-7.703a.29.29 0 0 0 0-.414z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.713 4.197c.484 0 .877.393.877.877v4.679a.877.877 0 0 1-1.754 0V5.074c0-.484.392-.877.877-.877",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.69 11.883a1.17 1.17 0 1 0 0 2.34 1.17 1.17 0 0 0 0-2.34"
  })));
};
export default SvgAlert;